import { render, staticRenderFns } from "./PreviewMail.vue?vue&type=template&id=2c20d9dc&scoped=true&"
import script from "./PreviewMail.vue?vue&type=script&lang=js&"
export * from "./PreviewMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20d9dc",
  null
  
)

export default component.exports